/* eslint-disable spaced-comment */
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'
//  两个<---sentry---> 注释之间的内容会被sentry-plugin替换
export default () => {
  if (process.env.BUILD_ENV !== 'production') return undefined
  Sentry.init({
      Vue,
      dsn:
        'https://1597823948e14b6f8001b697a051049d@sentry.mintegral.com/2',
      release: '2.1.23',
      integrations: [
      ],
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.5 : 1.0
    })
}
